export const getStorage = (key: string) => {
  return localStorage.getItem(key)
}
export const setStorage = (key: string, data: any) => {
  localStorage.setItem(key, data)
}
export const removeStorage = (key: string) => {
  localStorage.removeItem(key)
}
export const clearStorage = () => {}
